import {IComparisonOperator} from './comparison-operator.interface/comparison-operator.interface';

export abstract class BaseComparisonOperator implements IComparisonOperator {

  abstract compare(value1: unknown, value2: unknown): boolean;
}
